var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:marketing:ads:adv:list"],
            expression: "['platform:marketing:ads:adv:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
          formatter: _vm.formatter,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "mb8" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:marketing:ads:adv:save"],
                            expression: "['platform:marketing:ads:adv:save']",
                          },
                        ],
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增广告")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-adInfo",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _c("div", [_vm._v(_vm._s(row.adName))]),
                  _c("div", [_vm._v("广告位ID：" + _vm._s(row.id || "-"))]),
                ]),
              ]
            },
          },
          {
            key: "table-status",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-value": 1,
                        "inactive-value": 0,
                        "active-text": "开启",
                        "inactive-text": "关闭",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["platform:marketing:ads:adv:update"],
                                  expression:
                                    "['platform:marketing:ads:adv:update']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleAdCode(row)
                                },
                              },
                            },
                            [_vm._v("查看代码位")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["platform:marketing:ads:adv:update"],
                                  expression:
                                    "['platform:marketing:ads:adv:update']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["platform:marketing:ads:adv:delete"],
                                  expression:
                                    "['platform:marketing:ads:adv:delete']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑广告" : "新增广告",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            "close-on-click-modal": false,
            width: "800px",
            "before-close": _vm.closeEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                rules: _vm.formRules,
                model: _vm.form,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "广告名称：", prop: "adName" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入广告名称" },
                    model: {
                      value: _vm.form.adName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "adName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.adName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "平台：", prop: "platform" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: { size: "small", placeholder: "请选择" },
                      model: {
                        value: _vm.form.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "platform", $$v)
                        },
                        expression: "form.platform",
                      },
                    },
                    _vm._l(_vm.platformOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告类型：", prop: "adType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: { size: "small", placeholder: "请选择" },
                      model: {
                        value: _vm.form.adType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adType", $$v)
                        },
                        expression: "form.adType",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                      width: 35,
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 1000,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:marketing:ads:adv:save",
                            "platform:marketing:ads:adv:update",
                          ],
                          expression:
                            "['platform:marketing:ads:adv:save', 'platform:marketing:ads:adv:update']",
                        },
                      ],
                      attrs: { loading: _vm.loading, type: "primary" },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ad-code", {
        attrs: {
          id: _vm.adCode.id,
          "ad-type": _vm.adCode.adType,
          platform: _vm.adCode.platform,
          "app-list": _vm.appList,
        },
        model: {
          value: _vm.adCode.show,
          callback: function ($$v) {
            _vm.$set(_vm.adCode, "show", $$v)
          },
          expression: "adCode.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }